// Mirrors com.tookitaki.fraud_common.scoring.ScoringConfig.DeviationMaxConfig defaults
// Post-ADR-0003: defaultScores / defaultScore / hardActions removed.
// Per-rule scoreOverride + per-rule hardRule are the canonical scoring inputs.
export const DEFAULT_DEVIATION_MAX_CONFIG = Object.freeze({
  engineType: 'DeviationMax',
  thresholds: { lowMax: 33.0, mediumMax: 66.0 },
  deviationEnabled: false,
  minFraction: 0.7,
  capRatio: 10.0,
  curve: 'Log',
  aggregationMode: 'Max'
});

// FIN-12215: value-equality of two scoring configs, used to drive the
// dirty-state of the "Reset to defaults" button on both the scenario-level
// Alert Scoring tab and the tenant-level Settings > Scoring section.
const SCORING_SCALAR_KEYS = [
  'engineType',
  'deviationEnabled',
  'minFraction',
  'capRatio',
  'curve',
  'aggregationMode'
];
// FIN-13794 — treat missing / null lowMin as 0 for equality comparison so a form that
// carries `lowMin: undefined` compares equal to a server config that omits the field.
const lowMinOrZero = (t) =>
  t && typeof t.lowMin === 'number' && Number.isFinite(t.lowMin) ? t.lowMin : 0;

export const scoringConfigEquals = (a, b) => {
  if (!a || !b) return a === b;
  if (Number(a.thresholds?.lowMax) !== Number(b.thresholds?.lowMax))
    return false;
  if (Number(a.thresholds?.mediumMax) !== Number(b.thresholds?.mediumMax))
    return false;
  if (lowMinOrZero(a.thresholds) !== lowMinOrZero(b.thresholds)) return false;
  return SCORING_SCALAR_KEYS.every((k) => a[k] === b[k]);
};
